import React from "react";
//home page can be changed for any page
import CenterPanelCheckout from "./centerPanel";
import BottomPanelAppointment from "./bottomPanel";

export default function AppointmentContent() {
  return (
    <div className="appointment-checkout-step">
      <CenterPanelCheckout />
      <BottomPanelAppointment />
    </div>
  );
}
